import { render, staticRenderFns } from "./PerseuTableActionButton.vue?vue&type=template&id=dcf8434a"
import script from "./PerseuTableActionButton.vue?vue&type=script&lang=js"
export * from "./PerseuTableActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports